





















import Vue from "vue";
import LineChart from "@/components/LineChart.vue";
import Component from "vue-class-component";
import { movingAvg, round } from "@/utils/stats";

interface RegionDayStats {
  data: string;
  stato: string;
  codice_regione: number;
  denominazione_regione: string;
  lat: number;
  long: number;
  ricoverati_con_sintomi: number;
  terapia_intensiva: number;
  totale_ospedalizzati: number;
  isolamento_domiciliare: number;
  totale_positivi: number;
  variazione_totale_positivi: number;
  nuovi_positivi: number;
  dimessi_guariti: number;
  deceduti: number;
  totale_casi: number;
  tamponi: number;
}

interface Region {
  code: string;
  name: string;
}

@Component({
  components: {
    LineChart,
  },
})
export default class Regioni extends Vue {
  private loaded = false;
  private chartdata = {};
  private regions: Region[] = [];
  private region = "";
  private proCivData: RegionDayStats[] = [];
  private movingAverage = true;

  async mounted(): Promise<void> {
    this.loaded = false;

    if (this.$store.state.regionsData.length) {
      this.init(this.$store.state.regionsData);
      return;
    }

    fetch(
      "https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-regioni.json"
    )
      .then((res) => res.json())
      .then((proCivData: RegionDayStats[]) => {
        this.$store.state.regionsData = proCivData;
        this.init(proCivData);
      });
  }

  private init(proCivData: RegionDayStats[]): void {
    this.proCivData = proCivData;

    const inserted: string[] = [];

    const regions: Region[] = proCivData
      .reduce((carrier: Region[], stats) => {
        carrier.push({
          code: stats.denominazione_regione,
          name: stats.denominazione_regione,
        });

        return carrier;
      }, [])
      .filter((region) => {
        if (inserted.indexOf(region.code) > -1) {
          return false;
        }

        inserted.push(region.code);

        return region.code;
      })
      .sort((reg1, reg2) => {
        if (reg1.code === "Emilia-Romagna") {
          return -10;
        }
        if (reg2.code === "Emilia-Romagna") {
          return 10;
        }
        return reg1.name.localeCompare(reg2.name);
      });

    this.regions = regions;
    this.region = regions[0].code;

    this.plot(this.region);
  }

  private plot(regionName: string) {
    const labels: string[] = [];
    let deaths: number[] = [];
    let intensives: number[] = [];
    let cases: number[] = [];
    let positives: number[] = [];
    let news: number[] = [];
    let tests: number[] = [];

    const dataToPlot = this.proCivData.filter(
      (stats) => stats.denominazione_regione === regionName
    );

    dataToPlot.forEach((dayStats, index, self) => {
      labels.push(new Date(dayStats.data.substr(0, 10)).toLocaleDateString());
      let yesterdayDeaths = 0;
      if (self[index - 1]) {
        yesterdayDeaths = self[index - 1].deceduti;
      }
      deaths.push(dayStats.deceduti - yesterdayDeaths);
      intensives.push(dayStats.terapia_intensiva);
      cases.push(dayStats.totale_casi);
      positives.push(dayStats.totale_positivi);
      news.push(dayStats.nuovi_positivi);
      tests.push(dayStats.tamponi);
    });

    if (this.movingAverage) {
      deaths = round(movingAvg(deaths, 7));
      intensives = round(movingAvg(intensives, 7));
      cases = round(movingAvg(cases, 7));
      positives = round(movingAvg(positives, 7));
      news = round(movingAvg(news, 7));
      tests = round(movingAvg(tests, 7));
    }

    this.chartdata = {
      labels,
      datasets: [
        {
          label: "Deceduti",
          backgroundColor: "red",
          borderColor: "red",
          fill: false,
          hidden: true,
          data: deaths,
        },
        {
          label: "Terapia intensiva",
          backgroundColor: "darkorange",
          borderColor: "darkorange",
          fill: false,
          data: intensives,
        },
        {
          label: "Totale casi",
          backgroundColor: "navy",
          borderColor: "navy",
          fill: false,
          hidden: true,
          data: cases,
        },
        {
          label: "Positivi",
          backgroundColor: "orange",
          borderColor: "orange",
          fill: false,
          hidden: true,
          data: positives,
        },
        {
          label: "Nuovi positivi",
          backgroundColor: "blue",
          borderColor: "blue",
          fill: false,
          data: news,
        },
        {
          label: "Tamponi",
          backgroundColor: "pink",
          borderColor: "pink",
          fill: false,
          hidden: true,
          data: tests,
        },
      ],
    };

    this.loaded = true;
  }

  private rePlot() {
    this.plot(this.region);
  }
}
